// TODO DT-2805 Likert Scale

import { AerInputStructure } from "@aerstudios/aerated-aerinputstructure";
import { AerRadioGroup } from "@aerstudios/aerated-aerradiogroup";
import React, { useEffect, useState } from "react";
import * as styles from "./LikertScale.module.scss";

interface LikertOption {
	label: string;
	value: string;
}
export interface LikertScaleProps {
	// The name of the input
	name: string;
	// The element ID
	id: string;
	// The label for the likert scale
	label: string;
	// The range of the likert scale
	likertRange: [
		LikertOption,
		LikertOption,
		LikertOption,
		LikertOption,
		LikertOption,
	];

	// The value of the selected option
	value: string;
	// The function to call when an option is selected
	onChange: (value: string) => void;

	// An error message - will only be if it's required.
	errorMessage?: string;

	// If the element is visually hidden
	hidden?: boolean;
	// If the element is disabled
	disabled?: boolean;
	showAllScaleLabels?: boolean;
}

export const LikertScale: React.FC<LikertScaleProps> = ({
	name,
	id,
	label,
	value,
	onChange,
	errorMessage,
	hidden,
	likertRange,
	disabled,
	showAllScaleLabels = false,
}) => {
	const items = likertRange?.map((label, index) => ({
		label: index + 1,
		ariaLabel: label.label,
		value: label.value,
	}));

	const [key, setKey] = useState(0);

	// This is a hack to force the radio group to re-render first time and load the incoming value.
	useEffect(() => {
		setKey((prev) => prev + 1);
	}, []);

	return (
		<AerInputStructure.Root
			errorMessage={errorMessage}
			className={disabled ? styles.likertScaleDisabled : styles.likertScale}
			hidden={hidden}
		>
			<AerRadioGroup.Root
				key={`${key}-${disabled}`}
				className={styles.likertScaleGroup}
				id={id}
				groupLabel={
					(
						<div
							// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
							dangerouslySetInnerHTML={{
								__html: label,
							}}
						/>
					) as unknown as string
				}
				groupLabelClassName={styles.likertScaleGroupLabel}
				value={value}
				onKeyDown={(e) => {
					if (disabled || e.key === "Enter") {
						e.preventDefault();
					}
				}}
				name={name}
				onChange={(newValue) => {
					!disabled && onChange(newValue as string);
				}}
				disabled={disabled}
			>
				<div className={styles.likertScaleOptionsGroup}>
					<span
						className={
							disabled ? styles.backgroundBarDisabled : styles.backgroundBar
						}
						aria-hidden
					/>
					{items?.map((answer) => {
						return (
							<AerRadioGroup.Item
								className={styles.likertOption}
								key={answer.label}
								value={answer.value}
								checkedIcon={
									<span
										className={styles.likertOptionLabelSelected}
										title={answer.ariaLabel}
									>
										{answer.label}
									</span>
								}
								disabled={disabled}
								label={
									<span
										className={
											disabled
												? styles.likertOptionLabelDisabled
												: styles.likertOptionLabel
										}
										aria-label={answer.ariaLabel}
										title={answer.ariaLabel}
										// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
										dangerouslySetInnerHTML={{
											__html: answer.label,
										}}
									/>
								}
							/>
						);
					})}
				</div>

				<span
					className={
						!showAllScaleLabels
							? styles.likertScaleLabels
							: styles.likertScaleExtraLabels
					}
					aria-hidden
				>
					{likertRange.map(({ label: scale }, i) => (
						<span key={scale}>
							{(i === 0 || i === likertRange.length - 1) && scale}
						</span>
					))}
				</span>
			</AerRadioGroup.Root>

			<AerInputStructure.ErrorMessage />
		</AerInputStructure.Root>
	);
};
